import { render, staticRenderFns } from "./RobotManage.vue?vue&type=template&id=561822ee&scoped=true"
import script from "./RobotManage.vue?vue&type=script&lang=js"
export * from "./RobotManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561822ee",
  null
  
)

export default component.exports